import { operationalWeekendLabels } from '../../shared/operationalWeek.ts'

type OrderView = 'active' | 'awaiting' | 'history'
type DeliveryDay = 'saturday' | 'sunday' | null

export function ordersScopeDescription(view: OrderView, weekStartsAt: string) {
  if (view === 'awaiting') return 'Awaiting payment · all time. Recorded delivery weekdays; historical delivery dates are not verified.'
  if (view === 'history') return 'Order history · all time. Earlier and cancelled orders; historical delivery dates are not verified.'
  const weekend = operationalWeekendLabels(weekStartsAt)
  return `Current delivery weekend · ${weekend.saturday} · ${weekend.sunday} · Pacific/Auckland. Dates show current-week context.`
}

export function orderDeliveryLabel(day: DeliveryDay, view?: OrderView, weekStartsAt?: string) {
  if (!day) return 'Not recorded'
  if (view === 'active' && weekStartsAt) return operationalWeekendLabels(weekStartsAt)[day]
  return day === 'saturday' ? 'Saturday' : 'Sunday'
}
